import { Formik, Form } from "formik";
import { Button, Box, Flex } from "@chakra-ui/react";
import { useContext, useEffect, useState } from "react";
import { imageToBase64 } from "utils/functions/function";
import LogoViewer from "../LogoViewer/LogoViewer";
import { appRequest } from "routes";
import { AppContext } from "AppProvider/AppContext";
import debounce from "lodash/debounce";
import PreviewModal from "../PreviewModal/PreviewModal";
import TableForm from "./elements/TableForm";
import TabForm from "./elements/TabForm";
import TriggerForm from "./elements/TriggerForm";
import ApprovalsForm from "./elements/ApprovalsForm";
import DefineApproval from "./elements/DefineApproval";
import WorkFlowDesc from "./elements/WorkFlowDesc";
import DefineSettings from "./elements/DefineSettings";
import {
  generateApprovalsArray,
  generateLevels,
  transformFields,
  transformResponse,
} from "./utils/function";
import { formI } from "./utils/interface";
import {
  approvalModalOptions,
  defaultSchemaJson,
  filterIsActive,
  sortBy,
} from "./utils/constant";
import { formValidation } from "./utils/validation";
import NotificationTable from "./elements/NotificationsTable";

const WorkFlowForm = ({
  showError,
  loading,
  setShowError,
  submitForm,
  initialVal,
  onClose,
  type,
  setDeletedApproavals,
  activePage,
  setActiveSteps,
  setDisabledSteps,
  disabledSteps,
  steps,
  workflowProcess
}: formI) => {
  const [initialValues, setInitialValues] = useState(initialVal);
  const [schemaField, setSchemaField] = useState<any>(
    initialVal?.schema?.fields
      ? transformFields(initialVal?.schema?.fields)
      : defaultSchemaJson
  );
  const [testingInitialValues, setTestingInitialValues] = useState(null);
  const [userLoading, setUserLoading] = useState<Boolean>(false);
  const [schemaJsonData, setSchemaJsonData] = useState<any>(
    initialVal.schema || {}
  );
  const [settingCreateLoading, setSettingCreateLoading] = useState(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [data, setData] = useState<any>([]);
  const { toastNotify } = useContext(AppContext);
  const [logo, setLogo] = useState<any>({
    open: false,
    data: "",
  });
  const isDisabled = useState<boolean>(type === "View" ? true : false)[0];
  const [isPreviewOpen, setIsPreviewOpen] = useState<any>({
    open: false,
    data: "",
  });
  const [isSubmit, setIsSubmit] = useState<boolean>(false);

  console.log('the initialValues are', workflowProcess)

  // for logo viewer
  const handleOpenModal = (value: any) => {
    setLogo({
      open: true,
      data: { value },
    });
  };
  const handleCloseLogoModal = () => {
    setLogo({
      open: false,
      data: "",
    });
  };

  const handleOpenPreviewModal = (value: any) => {
    setIsPreviewOpen({
      open: true,
      data: { value },
    });
  };
  const handleClosePreviewModal = () => {
    setIsPreviewOpen({
      open: false,
      data: "",
    });
  };

  const handleLogoChange = (
    e: React.ChangeEvent<HTMLInputElement>,
    setFieldValue: any
  ) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.type.startsWith("image/")) {
        imageToBase64(file)
          .then((base64String: string) => {
            setFieldValue("logo", { name: file.name, file: base64String });
          })
          .catch((error: any) => {
            console.error("Error converting image to base64:", error);
          });
      } else {
        alert("please upload image");
      }
    }
  };
  const handleGetUser = async (currentP?: number, valu?: any) => {
    try {
      setUserLoading(true);
      let limit = 20;
      let sort = 1;
      let page = currentP ? currentP : 1;

      let dt: any = {
        limit,
        sort,
        page,
      };

      if (valu) {
        dt["value"] = valu;
      }
      const response: any = await appRequest("user", "get", dt);
      if (response) {
        if (Array.isArray(response.data)) {
          return response.data;
        } else {
          return [];
        }
      } else {
        toastNotify({
          title: `Error getting the user.`,
          message: response.message || "Something went wrong.",
          type: "error",
        });
      }
    } catch (error: any) {
      toastNotify({
        title: `Error getting the user.`,
        description: error.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setUserLoading(false);
    }
  };

  const handleWorkflowSetting = async (valu?: any, type?: string) => {
    try {
      setUserLoading(true);
      let dt: any = {
        title: valu,
        type: type,
      };
      const response: any = await appRequest("workflow", "getSetting", dt);
      if (response) {
        if (Array.isArray(response.data)) {
          return response.data;
        } else {
          return [];
        }
      } else {
        toastNotify({
          title: `Error getting the Workflow Setting.`,
          message: response.message || "Something went wrong.",
          type: "error",
        });
      }
    } catch (error: any) {
      console.log(error);
      toastNotify({
        title: `Error getting the Workflow Setting.`,
        description: error.message || "Something went wrong.",
        type: "error",
      });
    } finally {
      setUserLoading(false);
    }
  };

  // useEffect(() => {
  //   handleGetUser(1);
  // }, []);

  const debouncedLoadOptions = debounce(
    async (inputValue: string, callback: (options: any[]) => void) => {
      try {
        setIsLoading(true);
        let dt = await handleGetUser(1, inputValue);
        setIsLoading(false);
        if (dt.length === 0) {
          dt = [{ email: inputValue, id: inputValue, isText: 1 }];
        }
        callback(dt);
      } catch (error) {
        setIsLoading(false);
        callback([]);
      }
    },
    800
  );

  const debouncedFiltersLoadOptions = debounce(
    async (
      inputValue: string,
      type: string,
      callback: (options: any[]) => void
    ) => {
      try {
        setIsLoading(true);
        let dt = await handleWorkflowSetting(inputValue, type);
        setIsLoading(false);
        if (dt.length === 0) {
          dt = [
            { title: inputValue, _id: inputValue, type: type, addNew: true },
          ];
        }
        callback(dt);
      } catch (error) {
        setIsLoading(false);
        callback([]);
      }
    },
    800
  );

  const loadOptions = (
    inputValue: string,
    callback: (options: any[]) => void
  ) => {
    debouncedLoadOptions(inputValue, callback);
  };

  const loadFiltersOptions = (
    inputValue: string,
    type: string,
    callback: (options: any[]) => void
  ) => {
    debouncedFiltersLoadOptions(inputValue, type, callback);
  };

  const createWorkflowSettings = async (
    index: number,
    type: string,
    values: any,
    setFieldValue: any
  ) => {
    if (values) {
      try {
        let data: any = values[type][index];
        setSettingCreateLoading(true);
        let { addNew, ...rest } = data;
        const response: any = await appRequest("workflow", "settingCreate", {
          type: type,
          values: rest,
          title: type === "table" ? data?.header?.label : data.label,
        });
        if (response.status === "success") {
          if (type === "table") {
            const updatedTable = [...values.table];
            updatedTable[index] = {
              ...response.data.values,
              _id: response.data._id,
              addNew: false,
            };
            setFieldValue("table", updatedTable);
          }
          if (type === "filters") {
            const updatedFilter = [...values.filters];
            updatedFilter[index] = {
              ...response.data.values,
              _id: response.data._id,
              addNew: false,
            };
            setFieldValue("filters", updatedFilter);
          }
          toastNotify({
            title: `${type} Setting Created successfully`,
            message: response.message || "Something went wrong.",
            type: "success",
          });
        } else {
          toastNotify({
            title: `Error getting the workflow Setting.`,
            message: response.message || "Something went wrong.",
            type: "error",
          });
        }
      } catch (err: any) {
        console.log(err.message);
        toastNotify({
          title: `Error getting the workflow.`,
          message: err.message || "Something went wrong.",
          type: "error",
        });
      } finally {
        setSettingCreateLoading(false);
      }
    }
  };

  const handleFileLoad = (data: any, values: any) => {
    setSchemaJsonData(data);
    const fieldArray = transformFields(data.fields);
    const dt = initialValues.table.map((tableItem: any) => {
      return {
        ...tableItem,
        columnName: fieldArray.map((field: any) => {
          return {
            key: field.value,
            label: field.label,
            fieldType: field.type,
            isActive: true,
          };
        }),
      };
    });
    setSchemaField(fieldArray);
    setTestingInitialValues((prev: any) => {
      const newValues = {
        ...values,
        table: dt,
        sortBy: [
          {
            key: fieldArray[0],
            mode: sortBy[1],
            isActive: false,
          },
        ],
        searchFilter: {
          key: fieldArray[0],
          isActive: false,
        },
        filters: [
          {
            placeholder: "Select...",
            label: "Filter 1",
            key: fieldArray[0],
            isActive: filterIsActive[0],
            isMultiSelect: filterIsActive[0],
            filters: [{ key: "", label: "", isActive: true }],
          },
        ],
      };
      return newValues;
    });
  };

  useEffect(() => {
    if (testingInitialValues) {
      setInitialValues(testingInitialValues);
      setTestingInitialValues(testingInitialValues);
    }
  }, [testingInitialValues]);

  return (
    <Box>
      <Formik
        initialValues={testingInitialValues || initialValues}
        enableReinitialize
        onSubmit={(values, { resetForm }) => {

          const transformedValues = transformResponse(values);
          submitForm(
            { ...transformedValues, schema: schemaJsonData },
            resetForm
          );
          setDisabledSteps([0]);
          setActiveSteps(0);
        }}
        validationSchema={formValidation}
      >
        {({ values, errors, handleChange, setFieldValue }) => {

          return (
            <Form>
              <Box
                overflowX="auto"
                className="customScrollBar"
                maxH={{ base: "60vh", lg: "72vH" }}
                p={2}
              >
                {/* Workflow description */}
                <WorkFlowDesc
                  activePage={activePage}
                  showError={showError}
                  errors={errors}
                  values={values}
                  handleChange={handleChange}
                  isDisabled={isDisabled}
                  handleOpenModal={handleOpenModal}
                  generateApprovalsArray={generateApprovalsArray}
                  setFieldValue={setFieldValue}
                  handleLogoChange={handleLogoChange}
                  schemaJsonData={schemaJsonData}
                  setSchemaJsonData={setSchemaJsonData}
                  schemaField={schemaField}
                  isForeign={workflowProcess?.processName === "foreign"}
                  loadOptions={loadOptions}
                  isLoading={isLoading}
                />
                {/* User Approvals Form */}
                <ApprovalsForm
                  activePage={activePage}
                  values={values}
                  setFieldValue={setFieldValue}
                  isDisabled={isDisabled}
                  setDeletedApproavals={setDeletedApproavals}
                  type={type}
                  loadOptions={loadOptions}
                  data={data}
                  showError={showError}
                  generateLevels={generateLevels}
                  isLoading={isLoading}
                  debouncedLoadOptions={debouncedLoadOptions}
                />
                {/* Define Flow Settings */}
                <DefineSettings
                  activePage={activePage}
                  data={data}
                  isLoading={isLoading}
                  setFieldValue={setFieldValue}
                  loadFiltersOptions={loadFiltersOptions}
                  values={values}
                  isDisabled={isDisabled}
                  handleChange={handleChange}
                  settingCreateLoading={settingCreateLoading}
                  createWorkflowSettings={createWorkflowSettings}
                  showError={showError}
                  schemaField={schemaField}
                />
                {/* Define Notification */}
                <NotificationTable
                  activePage={activePage}
                  values={values}
                  setFieldValue={setFieldValue}
                  isDisabled={isDisabled}
                  generateLevels={generateLevels}
                />
                {/* Define File Approvals */}
                <DefineApproval
                  activePage={activePage}
                  isDisabled={isDisabled}
                  values={values}
                  setFieldValue={setFieldValue}
                  approvalModalOptions={approvalModalOptions}
                  setInitialValues={setInitialValues}
                  initialValues={initialValues}
                  handleFileLoad={handleFileLoad}
                />
                {/* Define Triggers */}
                <TriggerForm
                  activePage={activePage}
                  values={values}
                  setFieldValue={setFieldValue}
                  isDisabled={isDisabled}
                  generateLevels={generateLevels}
                />
                {/* Define Tab */}
                <TabForm
                  activePage={activePage}
                  setFieldValue={setFieldValue}
                  values={values}
                  isDisabled={isDisabled}
                />
                {/* Define Table */}
                <TableForm
                  activePage={activePage}
                  isDisabled={isDisabled}
                  values={values}
                  setFieldValue={setFieldValue}
                  loadFiltersOptions={loadFiltersOptions}
                  showError={showError}
                  data={data}
                  isLoading={isLoading}
                  createWorkflowSettings={createWorkflowSettings}
                  settingCreateLoading={settingCreateLoading}
                />
              </Box>
              {!isDisabled && (
                <Flex
                  gap={2}
                  position="absolute"
                  bottom={0}
                  right={0} // Align buttons to the bottom right corner
                // mb={2} // Add margin to separate from the bottom and right edges
                >
                  <Button
                    colorScheme="red"
                    mt={4}
                    onClick={() => {
                      onClose();
                      setActiveSteps(0);
                      setDisabledSteps([0]);
                    }}
                    w={{ base: "4rem", md: "5rem" }}
                  >
                    Cancel
                  </Button>
                  <Box display={activePage === 0 ? "none" : undefined}>
                    <Button
                      bg="teal.300"
                      color="white"
                      _hover={{ bg: "teal.400" }}
                      mt={4}
                      onClick={() => setActiveSteps(activePage - 1)}
                      w={{ base: "4rem", md: "5rem" }}
                    >
                      Back
                    </Button>
                  </Box>
                  {activePage < steps.length - 1 ? (
                    <Button
                      bg="teal.300"
                      color="white"
                      _hover={{ bg: "teal.400" }}
                      mt={4}
                      onClick={() => {
                        if (activePage < steps.length - 1) {
                          setDisabledSteps([...disabledSteps, activePage + 1]);
                          setActiveSteps(activePage + 1);
                        }
                      }}
                      isDisabled={
                        activePage === 0 &&
                        (values.workFlowName === "" || undefined)
                      }
                      w={{ base: "4rem", md: "5rem" }}
                    >
                      Next
                    </Button>
                  ) : isSubmit ? (
                    <Button
                      type="submit"
                      isLoading={loading}
                      bg="green.400"
                      color="white"
                      _hover={{ bg: "green.500" }}
                      mt={4}
                      onClick={() => {
                        setShowError(true);
                      }}
                      w={{ base: "4rem", md: "5rem" }}
                    >
                      Submit
                    </Button>
                  ) : (
                    <Button
                      bg="teal.300"
                      color="white"
                      _hover={{ bg: "teal.400" }}
                      mt={4}
                      onClick={() => handleOpenPreviewModal(values)}
                      w={{ base: "4rem", md: "5rem" }}
                    // isDisabled={activePage === 0 && (values.workFlowName === "" || undefined)}
                    >
                      Preview
                    </Button>
                  )}
                  {type === "edit" && (
                    <Button
                      type="submit"
                      bg="green.400"
                      isLoading={loading}
                      color="white"
                      _hover={{ bg: "green.500" }}
                      mt={4}
                      onClick={() => {
                        setShowError(true);
                      }}
                      w={{ base: "4rem", md: "5rem" }}
                    >
                      Save
                    </Button>
                  )}
                </Flex>
              )}
            </Form>
          );
        }}
      </Formik>
      <LogoViewer
        isOpen={logo.open}
        onClose={() => handleCloseLogoModal()}
        values={logo.data}
      />
      <PreviewModal
        isOpen={isPreviewOpen.open}
        onClose={() => handleClosePreviewModal()}
        values={isPreviewOpen.data}
        isSubmit={isSubmit}
        setIsSubmit={setIsSubmit}
        type={type}
      />
    </Box>
  );
};

export default WorkFlowForm;
